<template>
  <div class="flex flex-col gap-4">
    <!--
      Said plainly, not dressed up as a feature. A step that quietly asked for
      nothing would read as a step with nothing to ask.
    -->
    <DSAlert tone="neutral">
      <template #icon>
        <Wrench />
      </template>
      <DSAlertTitle>{{ label }} is still being built</DSAlertTitle>
      <DSAlertDescription>
        Nothing here is required — you can create the records without it and
        add this later.
      </DSAlertDescription>
    </DSAlert>

    <!--
      The assistant asks for what the step will collect. Answering does not fill
      anything yet, so it says so rather than appearing to save.
    -->
    <AssistantThread
      :question
      :suggestions
      placeholder="Answer here…"
      @suggest="emit('answer', $event)"
      @answer="emit('answer', $event)"
    />

    <p
      v-if="answered"
      class="text-xs font-medium text-muted-foreground"
      aria-live="polite"
    >
      Noted. This step does not record anything yet, so nothing has been saved
      from that answer.
    </p>
  </div>
</template>

<script setup lang="ts">
import { Wrench } from '@lucide/vue'

import { DSAlert, DSAlertDescription, DSAlertTitle } from '@ds'

import AssistantThread from './AssistantThread.vue'

/*
 * The body of a step that is not built yet. It reuses the 1d assistant thread
 * rather than a blank panel: the mechanism these steps will need is a
 * conversation about the gap, so the placeholder is the first half of it.
 */
defineProps<{
  label: string
  question: string
  suggestions: string[]
  /** Set once the user has answered, so the honest disclaimer appears. */
  answered?: boolean
}>()

const emit = defineEmits<{
  (e: 'answer', text: string): void
}>()
</script>
